const format: Record<string, string> = {
    questionnarie: 'questionnarie/main',
    filesManager: 'filesManager/main'
}

const transformRootPath: Record<string, string> = {
    dqp: 'dashboard/questionnarie/preview',
    dqe: 'dashboard/questionnarie/edit',
    dqpe: 'dashboard/questionnarie/permission',
    dcdl: 'dashboard/calendar/detail',
    ducdl: 'dashboard/schedule-user/detail',
    dcd: 'dashboard/calendar/',
    dcrf: 'dashboard/calendar/report-folio-list',
    ducrf: 'dashboard/schedule-user/report-folio-list',
    ducd: 'dashboard/schedule-user/',
    'dcr': 'dashboard/calendar/recurrence',
    'ducr': 'dashboard/schedule-user/recurrence',
    ducdld: 'dashboard/schedule-user/detail',
    dcdld: 'dashboard/calendar/detail',
    // USER_SCHEDULE_DETAIL = 'ducdld',
    d: 'dashboard',
    q: 'questionnarie',
    e: 'edit',
    p: 'preview',
    pe: 'permission',
}

const getLabelBreadCrumb: Record<string, string> = {
    eq: 'editEdit',
    pq: 'previewEdit',
    peq: 'permission',
    dcdl: 'scheduleList',
    ducdl: 'scheduleList',
    dcrf: 'reportFolio',
    ducrf: 'reportFolio',
    schedule: 'scheduleList',
    dcd: 'schedule',
    ducd: 'userSchedule',
    dcr: 'recurrence',
    ducdld: 'scheduleDetail',
    dcdld: 'scheduleDetail',
    ducr: 'recurrence',
}
export { format, transformRootPath, getLabelBreadCrumb }